import { render, staticRenderFns } from "./LayoutBack.vue?vue&type=template&id=314a2e3e&scoped=true&"
import script from "./LayoutBack.vue?vue&type=script&lang=js&"
export * from "./LayoutBack.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBack.vue?vue&type=style&index=0&id=314a2e3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314a2e3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('314a2e3e')) {
      api.createRecord('314a2e3e', component.options)
    } else {
      api.reload('314a2e3e', component.options)
    }
    module.hot.accept("./LayoutBack.vue?vue&type=template&id=314a2e3e&scoped=true&", function () {
      api.rerender('314a2e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LayoutBack.vue"
export default component.exports